import { create } from 'zustand';
import GameService from '../services/GameService';
import { inventoryManager } from '../managers/InventoryManager';
import { initStatsManager } from '../managers/StatsManager';

// Initialize GameService with API base URL from environment
const gameService = new GameService(process.env.REACT_APP_API_URL || '');

// Make gameService globally available
window.gameService = gameService;

const useGameStore = create((set, get) => ({
    // User data
    userId: null,
    username: null,
    walletAddress: null,
    petName: null,
    
    // Loading states
    isLoading: false,
    error: null,

    // Initialize user data from wallet
    initializeUser: async (walletAddress) => {
        set({ isLoading: true, error: null });
        //console.log('Initializing user with wallet:', walletAddress);
        
        try {            
            // Set wallet address in GameService first
            gameService.setWalletAddress(walletAddress);
            //console.log('GameService wallet set:', gameService.walletAddress);

            // Check if user exists
            const userData = await gameService.checkUser(walletAddress);
            //console.log('User data received:', userData);
    
            if (!userData) {
                set({ 
                    error: 'User not found',
                    isLoading: false 
                });
                return false;
            }
    
            if (!userData.id) {
                set({ 
                    error: 'Invalid user data - no ID found',
                    isLoading: false 
                });
                return false;
            }

            // Set wallet address in store before inventory initialization
            set(state => ({
                ...state,
                walletAddress
            }));
    
            // Initialize inventory manager with both userId and walletAddress
            //console.log('Initializing inventory with:', { userId: userData.id, walletAddress });
            await inventoryManager.initialize(userData.id, walletAddress);

            // Initialize stats manager
            await initStatsManager(userData.id, walletAddress);
    
            // Set remaining user data in store
            set(state => ({
                ...state,
                userId: userData.id,
                username: userData.username,
                petName: userData.pet_name,
                isLoading: false
            }));
    
            return true;
    
        } catch (error) {
            console.error('Error in initializeUser:', error);
            set({ 
                error: error.message,
                isLoading: false 
            });
            return false;
        }
    },

    // Clear user data on logout
    clearUser: () => {
        gameService.setWalletAddress(null);
        set({
            userId: null,
            username: null,
            walletAddress: null,
            petName: null,
            error: null
        });
    }
}));

export default useGameStore;